import OohAgencySelect from './OohAgencySelect';
import OohRouteSelect from './OohRouteSelect';
import OohDateSelect from './OohDateSelect';
import { ChangeHandler, DateChangeHandler } from '../../types';

interface OohControlsSectionProps {
  dateParamValue: string | null;
  agencyParamValue: string | null;
  routeParamValue: string | null;
  onDateChanged: DateChangeHandler;
  onAgencyChanged: ChangeHandler;
  onRouteChanged: ChangeHandler;
}

const OohControlsSection = ({
  dateParamValue,
  agencyParamValue,
  routeParamValue,
  onDateChanged,
  onAgencyChanged,
  onRouteChanged,
}: OohControlsSectionProps) => {
  return (
    <div className="flex items-end justify-between gap-2">
      <OohDateSelect
        dateInputValue={dateParamValue}
        dateChangeHandler={onDateChanged}
      />
      <OohAgencySelect
        agencyInputValue={agencyParamValue}
        agencyChangeHandler={onAgencyChanged}
      />
      <OohRouteSelect
        date={dateParamValue}
        agencyId={agencyParamValue}
        routeInputValue={routeParamValue}
        routeChangedHandler={onRouteChanged}
      />
    </div>
  );
};

export default OohControlsSection;
